<div class="counter-container">
  <div [class]="'d-flex justify-content-center align-items-center circle ' + (status || type)">
    <i *ngIf="status" class="icon sm-md white" [class]="defaultStatus + ' i-'+ status"></i>
    <i *ngIf="type" class="al-icon lg al-color white" [class]="'al-ico-type-'+ type.replace('_', '-')"></i>
  </div>
  <div class="counter-label" data-id="label">{{experimentsStatusLabels[(status|| type)]}}</div>
</div>
